// ── Tutorial localStorage Helpers ──
// Shared between store and components to avoid circular imports.

const TUTORIALS_SEEN_KEY = 'resonance_tutorials_seen';

export function hasSeenChapterIntro(chapter: number): boolean {
  try {
    const raw = localStorage.getItem(TUTORIALS_SEEN_KEY);
    if (!raw) return false;
    const seen: unknown = JSON.parse(raw);
    if (!Array.isArray(seen)) return false;
    return seen.includes(chapter);
  } catch {
    return false;
  }
}

export function markChapterIntroSeen(chapter: number): void {
  try {
    const raw = localStorage.getItem(TUTORIALS_SEEN_KEY);
    let seen: number[] = [];
    if (raw) {
      const parsed: unknown = JSON.parse(raw);
      if (Array.isArray(parsed)) {
        seen = parsed.filter((v): v is number => typeof v === 'number');
      }
    }
    if (!seen.includes(chapter)) {
      seen.push(chapter);
    }
    localStorage.setItem(TUTORIALS_SEEN_KEY, JSON.stringify(seen));
  } catch {
    /* localStorage unavailable */
  }
}
